import { Injectable } from '@angular/core'
import { AngularFireDatabase } from '@angular/fire/compat/database'
import { BehaviorSubject } from 'rxjs'
import { IComment } from 'app/interfaces/IComment'
import { nanoid } from 'nanoid'
import { UserService } from 'app/core/user/user.service'
import { ChatContextEnum } from 'app/enums/ChatContextEnum'

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  chatContext: ChatContextEnum = ChatContextEnum.SURVEY_BUILDER
  comments$ = new BehaviorSubject<IComment[]>([])

  constructor(
    private db: AngularFireDatabase,
    private userService: UserService
  ) {
  }

  listenToChatComments(surveyKey: string) {
    this.db.object<Record<string, IComment>>(`comments/${this.chatContext}/${surveyKey}`)
      .valueChanges()
      .subscribe((comments: Record<string, IComment>) => {
        this.comments$.next(Object.values(comments ?? []).sort((a, b) => +new Date(a.timestamp) - +new Date(b.timestamp)))
      })
  }

  async saveCommentToFirebase(text: string, surveyKey: string, questionKey: string) {
    const comment: IComment = {
      key: nanoid(7),
      text,
      referenceKey: questionKey,
      timestamp: new Date(),
      userId: this.userService.user.id.toString(),
      userName: this.userService.user.name
    }
    await this.db.object(`comments/${this.chatContext}/${surveyKey}/${comment.key}`).update(comment)
  }

  async flushCommentsFromTestingGround() {
    await this.db.object(`comments/${ChatContextEnum.TESTING}`).remove()
  }

}
